<div class="py-[40px] md:py-[50px]">
    <div class="container mx-auto px-[12px] 2xl:px-0">

        <!-- Encabezado centrado -->
        <div class="text-center mb-[24px] md:mb-[32px]">
            <h2 class="text-Navy uppercase tracking-wider font-medium text-[12px] md:text-[13px] mb-[6px]"
                data-aos="fade-up" data-aos-duration="500">
                <span>{{ titleParts[0] }}</span>|<strong class="font-bold">{{ titleParts[1] }}</strong>
            </h2>
            <p class="text-[#4c4c4c] text-[13px] md:text-[14px]"
               data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">
                {{ texts?.featureH_Section?.subtitle }}
            </p>
        </div>

        <!-- Métricas: 3 columnas con divisores -->
        <div class="grid grid-cols-1 md:grid-cols-3 border-t border-b border-gray-200 divide-y md:divide-y-0 md:divide-x divide-gray-200">

            <div class="flex items-center px-[24px] xl:px-[50px] py-[20px] md:py-[24px]"
                 data-aos="fade-up" data-aos-duration="500" data-aos-delay="100">
                <div class="self-center font-serif leading-none font-bold text-[40px] md:text-[44px] lg:text-[52px] xl:text-[56px] text-Navy whitespace-nowrap">
                    {{ texts?.featureH_Section?.num_feature_one }}
                </div>
                <div class="self-center ml-[14px] xl:ml-[18px]">
                    <span class="block text-[#4c4c4c] text-[12px] md:text-[13px] lg:text-[14px] leading-[1.45] max-w-[120px] whitespace-pre-line">{{ texts?.featureH_Section?.text_feature_one }}</span>
                </div>
            </div>

            <div class="flex items-center px-[24px] xl:px-[50px] py-[20px] md:py-[24px]"
                 data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
                <div class="self-center font-serif leading-none font-bold text-[40px] md:text-[44px] lg:text-[52px] xl:text-[56px] text-Navy whitespace-nowrap">
                    {{ texts?.featureH_Section?.num_feature_two }}
                </div>
                <div class="self-center ml-[14px] xl:ml-[18px]">
                    <span class="block text-[#4c4c4c] text-[12px] md:text-[13px] lg:text-[14px] leading-[1.45] max-w-[120px] whitespace-pre-line">{{ texts?.featureH_Section?.text_feature_two }}</span>
                </div>
            </div>

            <div class="flex items-center px-[24px] xl:px-[50px] py-[20px] md:py-[24px]"
                 data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">
                <div class="self-center font-serif leading-none font-bold text-[40px] md:text-[44px] lg:text-[52px] xl:text-[56px] text-Navy whitespace-nowrap">
                    {{ texts?.featureH_Section?.num_feature_three }}
                </div>
                <div class="self-center ml-[14px] xl:ml-[18px]">
                    <span class="block text-[#4c4c4c] text-[12px] md:text-[13px] lg:text-[14px] leading-[1.45] max-w-[120px] whitespace-pre-line">{{ texts?.featureH_Section?.text_feature_three }}</span>
                </div>
            </div>

        </div>
    </div>
</div>
